import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MenuScreenEntity } from '../../domain/entities/MenuScreenEntity'
import type { MenuScreenAdminDto } from '@/backend/market'

export class MenuScreenModel extends MenuScreenEntity {
  constructor(dataDto: MenuScreenAdminDto) {
    super()
    mapEntityProperties<MenuScreenEntity>(this, dataDto)
  }
}
